import React from 'react';
import styled from '@emotion/styled';
import { colors, fontFamilies } from '../baseStyle/Variables';
import { Popover, PopoverTrigger, PopoverContent, PopoverDescription } from '../popover/popover';
import { useTranslation } from 'react-i18next';

type LeaseTermsTooltipProps = {
  styling?: any;
  shortened?: boolean;
};

const DetailText = styled.div`
  text-align: left;
  font-size: 0.8rem;
  max-width: 250px;
  color: ${colors.almostBlack};
  background-color: ${colors.white} !important;
  font-family: ${fontFamilies.interLight};
  padding: 0.8rem !important;
  border: none;
  box-shadow: 0px 2px 6px ${colors.darkGray} !important;
}
`;

const LeaseTermsTooltip: React.FC<LeaseTermsTooltipProps> = ({ styling, shortened = true }) => {
  const { t } = useTranslation();

  const fullText = <DetailText>{t(($) => $.componentLeaseTermsTooltip.leaseTooltipFull)}</DetailText>;

  const shortenedText = <DetailText>{t(($) => $.componentLeaseTermsTooltip.leaseTooltipShortened)}</DetailText>;

  return (
    <Popover>
      <PopoverTrigger
        style={{
          display: 'inline-block',
          background: 'none',
          border: 'none',
          textDecoration: 'underline',
          color: colors.koalafiBlue,
          fontFamily: fontFamilies.interSemiBold,
          fontSize: '0.75rem',
          padding: '0',
          // buttons center their text, so a label that wraps (the Spanish one does) drifts away from the surrounding copy
          textAlign: 'left',
          ...styling,
        }}
      >
        {t(($) => $.componentLeaseTermsTooltip.leaseToOwn)}
      </PopoverTrigger>
      <PopoverContent style={{ zIndex: '2', display: 'inline-block' }} className="Popover">
        <PopoverDescription>{shortened ? shortenedText : fullText}</PopoverDescription>
      </PopoverContent>
    </Popover>
  );
};

export default LeaseTermsTooltip;
